import { useLocation } from "react-router-dom"; // Import useLocation to get current path 

import { Fragment } from "react";  
import NavbarWithLogout from "../ui/NavbarWithLogout";

function NavbarLayout({ children }) { 
  const location = useLocation();
  // Paths where the navbar should not appear 
  const noNavbarRoutes = ["/","/SimpleLogin", "/RegisterAccount", "/forgot/password"]; 

  return ( 
    <Fragment> 
      {!noNavbarRoutes.includes(location.pathname) && <NavbarWithLogout />} 
      {children} 
    </Fragment> 
  ); 
} 

export default NavbarLayout; 